import { useState, useEffect, useRef } from 'react'
import { Popover } from 'antd'
import { navbar } from '../config'
import styles from './navbar.module.less'
import logo from '@/assets/images/home/logo.svg'
import array from '@/assets/images/home/array.svg'
import arrayActive from '@/assets/images/home/array_active.svg'

const Navbar = ({ activeNav, setActiveNavAndAnchor }: any) => {
  const [enterKey, setEnterKey] = useState('')
  const [isVisible, setIsVisible] = useState(true)
  const lastScrollY = useRef(0)
  const navbarRef = useRef<HTMLDivElement>(null)
  const SCROLL_THRESHOLD = 100 // 滚动阈值（像素）
  const DEBOUNCE_TIME = 100 // 防抖时间（毫秒）

  // 滚动事件处理器（带防抖）
  const handleScroll = () => {
    const currentScrollY = window.scrollY

    if (Math.abs(currentScrollY - lastScrollY.current) < 50) return

    // 向下滚动超过阈值时隐藏
    if (
      currentScrollY > lastScrollY.current &&
      currentScrollY > SCROLL_THRESHOLD
    ) {
      setIsVisible(false)
    } else if (currentScrollY < lastScrollY.current) {
      // 向上滚动时显示
      setIsVisible(true)
    }

    lastScrollY.current = currentScrollY
  }

  useEffect(() => {
    let timeoutId: NodeJS.Timeout

    const throttledScroll = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(handleScroll, DEBOUNCE_TIME)
    }

    window.addEventListener('scroll', throttledScroll)
    return () => {
      window.removeEventListener('scroll', throttledScroll)
      clearTimeout(timeoutId)
    }
  }, [])
  return (
    <header
      ref={navbarRef}
      className={`bg-[#22163570] fixed w-full h-auto  top-0 z-50 transition-transform duration-200 ease-out ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <nav className="flex items-center sm:py-[20px] py-[10px] sm:w-[80%] w-[90%] mx-auto">
        <div className="flex items-center w-full justify-between">
          {/* logo */}
          <div className="flex items-center">
            <img className="h-3 sm:h-6 w-auto" src={logo} />
          </div>
          {/* menu */}
          <div
            id="home-menu"
            className="flex justify-between h-8 items-center text-base font-medium text-dark-300"
          >
            {navbar.map(item => (
              <div
                key={`desktop-nav-link-${item.key}`}
                className={`block px-4 py-1 tracking-wide relative cursor-pointer ${styles.navbar}`}
                onClick={() => {
                  setActiveNavAndAnchor(item, {
                    anchor: 'prd_chat',
                    timestamp: new Date().getTime(),
                  })
                }}
              >
                {item.menu ? (
                  <Popover
                    getPopupContainer={node => {
                      return node
                    }}
                    content={item.menu.map(i => {
                      return (
                        <div
                          key={i.label}
                          onClick={e => {
                            e.stopPropagation()
                            setActiveNavAndAnchor(item, {
                              anchor: i.anchor,
                              timestamp: new Date().getTime(),
                            })
                          }}
                          className="linear-bg text-center cursor-pointer text-gray-300 pt-[10px] px-[20px] pb-[10px] text-[10px] lg:text-[14px] md:text-[14px] sm:text-[12px]"
                        >
                          {i.label}
                        </div>
                      )
                    })}
                    arrow={false}
                    trigger="hover"
                    color="transparent"
                  >
                    <div
                      className="flex-center"
                      onMouseEnter={() => {
                        setEnterKey(item.key)
                      }}
                      onMouseLeave={() => {
                        setEnterKey('')
                      }}
                    >
                      <span
                        style={{
                          fontWeight:
                            enterKey === item.key || activeNav.key === item.key
                              ? '600'
                              : '400',
                        }}
                        className={`list-text ${(enterKey === item.key || activeNav.key === item.key) && 'linear-text'} text-[10px] lg:text-[16px] md:text-[16px] sm:text-[16px]`}
                      >
                        {item.label}
                      </span>
                      &nbsp;&nbsp;
                      {enterKey === item.key || activeNav.key === item.key ? (
                        <img
                          className="h-[6px] sm:h-[8px]"
                          src={arrayActive}
                          alt=""
                        />
                      ) : (
                        <img
                          className="h-[6px] sm:h-[8px]"
                          src={array}
                          alt=""
                        />
                      )}
                    </div>
                  </Popover>
                ) : (
                  <div
                    onMouseEnter={() => {
                      setEnterKey(item.key)
                    }}
                    onMouseLeave={() => {
                      setEnterKey('')
                    }}
                    style={{
                      fontWeight:
                        enterKey === item.key || activeNav.key === item.key
                          ? '600'
                          : '400',
                    }}
                    className={`list-text ${activeNav.key === item.key && styles.linearText} text-[10px] sm:text-[16px]`}
                  >
                    {item.label}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Navbar
